import SearchAppController from '@/search/Controllers/SearchAppController';
import SearchController from '@/search/Controllers/SearchController';
import { initPlpBVZeroReviews } from '@/utils/Controllers/Bazaarvoice/BVZeroReviewsController';

document.addEventListener('DOMContentLoaded', () => {
  SearchAppController();
  SearchController();
  initPlpBVZeroReviews();
});
